<template>
  <div>
    <LayoutHeaderSearch v-if="header.type === HEADER_TYPE.SEARCH" />
    <LayoutHeaderCustom v-if="header.type === HEADER_TYPE.CUSTOM" />
  </div>
</template>

<script>
import LayoutHeaderSearch from "@/components/LayoutHeaderSearch/LayoutHeaderSearch";
import LayoutHeaderCustom from "@/components/LayoutHeaderCustom/LayoutHeaderCustom";
import { HEADER_TYPE } from "@/utils/constants/constants";

export default {
  name: "LayoutHeader",
  components: {
    LayoutHeaderSearch,
    LayoutHeaderCustom,
  },
  data() {
    return {
      HEADER_TYPE,
    };
  },
  computed: {
    header() {
      return this.$store.getters["layout/header"];
    },
  },
};
</script>

<style scoped></style>
